import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Drawer,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DocumentItem from "../../../Components/Masters/DocumentItem";
import { formatDate } from "../../../utils/formatDate";

function ViewData({
  title,
  inputData,
  element,
  viewData,
  setViewData,
  handleEdit,
  setData,
}) {
  const [filteredData, setFilteredData] = useState({});

  useEffect(() => {
    if (element) {
      setFilteredData(element);
    }
  }, [element]);

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.5rem",
        maxWidth: "100%",
        height: "100vh",
        justifyContent: "space-between",
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          onClick={() => {
            setViewData(false);
            setData({});
          }}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{ p: 3, width: "100%", backgroundColor: "#fff", overflow: "auto" }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",
            mb: 2,
          }}
        >
          {title}
        </Typography>
        <Grid
          spacing={2}
          sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}
        >
          {inputData?.map((input) => {
            let value = filteredData?.[input.fieldName];

            if (input.fieldName === "maintenanceFrequency") {
              value =
                filteredData?.maintenanceFrequency ||
                filteredData?.frequencyOfMaintenancePerYear;
            }

            if (input.fieldName === "energyOrFuelUsedForMaintenance") {
              value =
                filteredData?.energyOrFuelUsedForMaintenance ||
                filteredData?.energyTypeRequiredForUse ||
                filteredData?.energyTypeRequired;
            }

            if (input.fieldName === "recyclableComponentsPercentage") {
              value =
                filteredData?.recyclableComponentsPercentage ||
                filteredData?.replacementParts;
            }

            if (input.fieldName === "averageDisposalMethodByCustomers") {
              value =
                filteredData?.averageDisposalMethodByCustomers ||
                filteredData?.disposalMethod;
            }

            if (
              (input.fieldName === "date" ||
                input.fieldName === "dateOfSale") &&
              value
            ) {
              value = formatDate(value);
            }

            if (input.fieldName === "unitOfProductSold" && value) {
              if (typeof value === "object") {
                const qty =
                  value.value !== undefined && value.value !== null
                    ? value.value
                    : "";
                const unit = value.unit || "";
                const combined = `${qty} ${unit}`.trim();
                value = combined || "-";
              }
            }

            if (value === undefined || value === null || value === "") {
              value = "-";
            }

            return (
              <Grid item xs={12} sm={12} key={input.fieldName} mb={1}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: "bold",
                    wordBreak: "break-word",
                  }}
                >
                  {input.title}
                </Typography>
                <div style={{ wordBreak: "break-word" }}>{value}</div>
              </Grid>
            );
          })}
        </Grid>

        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Documents (optional)
          </Typography>
          {/* Render Images First */}
          {element && element?.documents?.length > 0 ? (
            <Box
              display="flex"
              flexDirection="column"
              gap={2}
              sx={{ width: "100%" }}
            >
              <Box display="flex" flexWrap="wrap" gap={1}>
                {element?.documents
                  .filter((url) =>
                    ["png", "jpg", "jpeg"].includes(
                      url.split(".").pop().toLowerCase()
                    )
                  )
                  ?.map((url, index) => (
                    <DocumentItem key={`image-${index}`} url={url} />
                  ))}
              </Box>

              {/* Render Other Documents */}
              <Box display="flex" flexWrap="wrap" gap={1}>
                {element?.documents
                  .filter(
                    (url) =>
                      !["png", "jpg", "jpeg"].includes(
                        url.split(".").pop().toLowerCase()
                      )
                  )
                  ?.map((url, index) => (
                    <DocumentItem key={`file-${index}`} url={url} />
                  ))}
              </Box>
            </Box>
          ) : (
            <Typography>-</Typography>
          )}
        </Box>

        <Button
          variant="contained"
          sx={{ mt: 2, backgroundColor: "#0a3f73", textTransform: "none" }}
          onClick={() => handleEdit(element)}
        >
          Edit
        </Button>
      </Box>
    </Box>
  );

  return (
    <Drawer
      anchor="right"
      open={viewData}
      onClose={() => {
        setViewData(false);
        setData({});
      }}
      sx={{
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
    >
      {list()}
    </Drawer>
  );
}

export default ViewData;

